import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { defineMessages, useIntl } from 'react-intl';
import Button from 'components/utils/button';
import { ID } from 'utils/constants';
import { getSearchParam } from 'utils/params';

const intlMessages = defineMessages({
  transcript: {
    id: 'button.transcript.aria',
    description: 'Aria label for the transcript button',
    defaultMessage: 'Transcript',
  },
});

const propTypes = { openModal: PropTypes.func };
const defaultProps = { openModal: () => {} };

const Transcript = ({ openModal }) => {
  const intl = useIntl();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    let meetingId = getSearchParam('meetingId');

    if (!meetingId) {
        const match = window.location.pathname.match(/\/presentation\/([^/]+)/);
        if (match && match[1]) {
            meetingId = match[1];
        }
        const parts = window.location.pathname.split('/');
        const potentialId = parts[parts.length - 1];
        if (potentialId && potentialId.match(/^[a-z0-9]{40}-[0-9]{13}$/)) {
            meetingId = potentialId;
        }
    }

    if (!meetingId) return;

    const url = `/presentation/${meetingId}-summary/transcript.json`;

    fetch(url, { method: 'HEAD' })
      .then(response => {
        if (response.ok) {
          setVisible(true);
        }
      })
      .catch(() => {
        // Ignore errors, button just won't show
      });
  }, []);

  if (!visible) return null;

  return (
    <Button
      aria={intl.formatMessage(intlMessages.transcript)}
      handleOnClick={() => openModal(ID.TRANSCRIPT)}
      label={intl.formatMessage(intlMessages.transcript)}
    />
  );
};

Transcript.propTypes = propTypes;
Transcript.defaultProps = defaultProps;

export default Transcript;
